import React from 'react';
import * as R from 'ramda';

import Chip from '@mui/material/Chip';
import Icon from '@mui/material/Icon';

import { withTranslation } from 'react-i18next';

const FormAttrSelector = ({
  data, onSelect, i18n, projectAttr,
}) => {
  return (
    <ul style={{ textAlign: 'left' }}>
      {data.map((t, index) => {
        const selectedAttr = R.find(R.propEq('key', t.key))(projectAttr);
        return (
          <li
            key={index + t.key}
            style={{ listStyleType: 'none', marginBottom: '4px' }}
          >
            <Chip
              color={selectedAttr !== undefined ? 'primary' : 'secondary'}
              deleteIcon={selectedAttr !== undefined ? null : <Icon>add</Icon>}
              label={R.path(['label', i18n.language], t)}
              onClick={e => onSelect(e, t.key, t.fieldCategory)}
              onDelete={e => onSelect(e, t.key, t.fieldCategory)}
            />
          </li>);
      })}
    </ul>
  );
};

export default withTranslation('translations')(FormAttrSelector);
